/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elegant_Loud_Iguana_SlurpInputs */

const es_elegant_loud_iguana_slurp = /** @type {(inputs: Elegant_Loud_Iguana_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acepto los`)
};

const gl_elegant_loud_iguana_slurp = /** @type {(inputs: Elegant_Loud_Iguana_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acepto o`)
};

const en_elegant_loud_iguana_slurp = /** @type {(inputs: Elegant_Loud_Iguana_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I accept the`)
};

/**
* | output |
* | --- |
* | "I accept the" |
*
* @param {Elegant_Loud_Iguana_SlurpInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const elegant_loud_iguana_slurp = /** @type {((inputs?: Elegant_Loud_Iguana_SlurpInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elegant_Loud_Iguana_SlurpInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_elegant_loud_iguana_slurp(inputs)
	if (locale === "en") return en_elegant_loud_iguana_slurp(inputs)
	return es_elegant_loud_iguana_slurp(inputs)
});